import { Dialog, DialogProps, IconButton, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { XIcon } from '../icons/FormIcons'

/**
 * Overrides default of the MUI Dialog component.
 * Makes dialog fullScreen for small screens.
 * Adds a floating "close" (X) button to the dialog
 */
export const DialogBase: React.FC<DialogProps & { closeDialog: () => void; disableCloseButton?: boolean }> = props => {
  const theme = useTheme()
  const upSm = useMediaQuery(theme.breakpoints.up('sm'))
  const { closeDialog, disableCloseButton, ...dialogProps } = props
  return (
    <Dialog fullScreen={!upSm} {...dialogProps}>
      <IconButton
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          color: theme => theme.palette.grey.grey03,
        }}
        size="large"
        onClick={closeDialog}
        disabled={disableCloseButton}
      >
        <XIcon />
      </IconButton>
      {props.children}
    </Dialog>
  )
}
